var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1Selected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90486 4.10156H10.8321C11.1554 4.10156 11.4171 3.83906 11.4171 3.51562V0.585938C11.4171 0.2625 11.1554 0 10.8321 0H7.90486C7.58193 0 7.31982 0.2625 7.31982 0.585938V3.51562C7.31982 3.83906 7.58189 4.10156 7.90486 4.10156Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7069 11.5955C16.0314 11.5955 15.4838 12.1436 15.4838 12.8193V11.7178C15.4839 11.0417 14.9357 10.494 14.2611 10.4939C13.5855 10.4939 13.0379 11.0416 13.0379 11.7178V10.4939C13.0381 9.81801 12.49 9.26961 11.8152 9.26972C11.1397 9.26972 10.5921 9.81777 10.5921 10.4939V6.65879C10.5931 5.97301 10.0254 5.41777 9.33969 5.43496C8.67157 5.45058 8.14622 6.01426 8.14622 6.6834V13.7639L6.90672 12.5232C6.42243 12.0384 5.63457 12.0462 5.15899 12.5412C4.69524 13.0248 4.72059 13.7975 5.19411 14.2713L6.92426 16.0029C7.73043 16.81 8.03235 17.7943 8.31043 18.8752C8.36309 19.0592 8.40012 19.2787 8.42899 19.4936C8.46797 19.7838 8.71606 20.0002 9.0086 20.0002H9.36821H16.1863C16.4528 20.0002 16.6859 19.82 16.7525 19.5615C16.9225 18.9018 17.1554 18.1596 17.3692 17.7982C17.7327 17.1834 17.9297 16.4846 17.9297 15.7705V12.8193C17.9297 12.1432 17.3815 11.5955 16.7069 11.5955Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2145 6.59862H17.1527C17.5997 6.61269 17.8977 6.07015 17.6472 5.6998L15.683 2.58534C15.4699 2.2196 14.8974 2.2196 14.6846 2.58534L12.72 5.6998C12.4697 6.06999 12.7681 6.61269 13.2145 6.59862Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16758 5.07812C6.16758 3.94727 5.24867 3.02734 4.11914 3.02734H4.11875C2.98883 3.02773 2.07031 3.94727 2.07031 5.07812C2.07031 6.20898 2.98883 7.12852 4.11875 7.12891H4.11914C5.24867 7.12891 6.16758 6.20898 6.16758 5.07812Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1Selected);
export default __webpack_public_path__ + "static/media/step1-selected.c9f39109dfe8453c794b0df0dabed5d0.svg";
export { ForwardRef as ReactComponent };